import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark text-gray-400 py-12 border-t border-white/5" data-id="element-46">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-47">
          <div className="max-w-3xl mx-auto text-center" data-id="element-48">
            <h4 className="text-white font-serif text-xl mb-6" data-id="element-49">
              Agente de Citas para Bienes Raíces
            </h4>

            <div className="bg-white/5 p-6 rounded-lg mb-8 text-xs leading-relaxed text-gray-500 text-left" data-id="element-50">
              <p className="mb-2 uppercase font-bold text-gray-400" data-id="element-51">
                Nota Legal y Descargo de Responsabilidad
              </p>
              <p data-id="element-52">
                Este libro es una guía educativa e informativa. El autor no
                garantiza ingresos específicos ni resultados financieros. El
                éxito en esta actividad depende del esfuerzo individual, la
                constancia y la capacidad de gestión de cada persona. Este
                material no constituye asesoría legal, migratoria o financiera.
                Los nombres de plataformas (Facebook, WhatsApp, etc.) son marcas
                registradas de sus respectivos dueños.
              </p>
            </div>

            <div className="flex items-center justify-center gap-6 mb-6" data-id="element-53">
              <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-400 hover:text-white transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-white" data-id="element-54">
                Política de Privacidad
              </button>
              <span className="text-gray-600" data-id="element-55">|</span>
              <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-400 hover:text-white transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-white" data-id="element-56">
                Términos y Condiciones
              </button>
            </div>

            <p className="text-sm" data-id="element-57">
              &copy; {new Date().getFullYear()} Agente de Citas para Bienes
              Raíces. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-58">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-59">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-[#0f1a2e] border border-white/10 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-60">
              <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-61">
                <h2 className="text-white font-serif text-xl" data-id="element-62">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10" aria-label="Cerrar" data-id="element-63">
                  <XIcon className="w-5 h-5" data-id="element-64" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-65">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-66" /> : <TermsContent data-id="element-67" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gray-400 text-xs" data-id="element-68">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="text-white font-semibold text-base mt-2" data-id="element-69">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-70">
        Recopilamos información personal que usted nos proporciona
        voluntariamente al realizar una compra, como su nombre, dirección de
        correo electrónico y datos de pago. No recopilamos información adicional
        sin su consentimiento.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-71">
        2. Uso de la Información
      </h3>
      <p data-id="element-72">Utilizamos su información personal exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 text-gray-400" data-id="element-73">
        <li data-id="element-74">Procesar y entregar su compra</li>
        <li data-id="element-75">Enviar actualizaciones relacionadas con el producto adquirido</li>
        <li data-id="element-76">Responder a consultas o solicitudes de soporte</li>
      </ul>

      <h3 className="text-white font-semibold text-base" data-id="element-77">
        3. Protección de Datos
      </h3>
      <p data-id="element-78">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-79">
        4. Compartir Información
      </h3>
      <p data-id="element-80">
        No vendemos, comercializamos ni transferimos su información personal a
        terceros, excepto proveedores de servicios de pago necesarios para
        procesar su transacción.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-81">5. Cookies</h3>
      <p data-id="element-82">
        Nuestro sitio puede utilizar cookies para mejorar la experiencia del
        usuario. Usted puede configurar su navegador para rechazar cookies,
        aunque esto podría afectar la funcionalidad del sitio.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-83">6. Sus Derechos</h3>
      <p data-id="element-84">
        Usted tiene derecho a acceder, rectificar o eliminar su información
        personal en cualquier momento. Para ejercer estos derechos, puede
        comunicarse con nosotros a través de los canales disponibles en nuestro
        sitio.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-400 text-xs" data-id="element-85">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="text-white font-semibold text-base mt-2" data-id="element-86">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-87">
        Al acceder a este sitio web y/o adquirir nuestros productos digitales,
        usted acepta cumplir con estos términos y condiciones. Si no está de
        acuerdo con alguno de estos términos, le recomendamos no utilizar
        nuestro sitio.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-88">
        2. Producto Digital
      </h3>
      <p data-id="element-89">
        El producto ofrecido es un libro digital (eBook) de carácter educativo e
        informativo. El contenido tiene fines de orientación general y no
        constituye asesoría profesional legal, financiera o migratoria.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-90">
        3. Descargo de Responsabilidad
      </h3>
      <p data-id="element-91">
        No garantizamos resultados específicos, ingresos o beneficios
        financieros derivados de la aplicación del contenido de este libro. Los
        resultados dependen del esfuerzo, dedicación y circunstancias
        individuales de cada persona.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-92">
        4. Política de Reembolso
      </h3>
      <p data-id="element-93">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. No se ofrecen reembolsos una vez que el producto ha sido
        entregado y descargado, salvo en casos excepcionales evaluados
        individualmente.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-94">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-95">
        Todo el contenido del libro y de este sitio web está protegido por
        derechos de autor. Queda prohibida la reproducción, distribución o
        modificación del contenido sin autorización expresa por escrito del
        autor.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-96">6. Uso Permitido</h3>
      <p data-id="element-97">
        El producto adquirido es para uso personal y no transferible. No está
        permitido compartir, revender o distribuir el contenido a terceros por
        ningún medio.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-98">7. Modificaciones</h3>
      <p data-id="element-99">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en este sitio.
      </p>
    </>;
}